import { FieldNames } from "../edit_connection/constants"

export const validateConnectionFormSubmit = (values, loading, invalid, pristine) => {
  const hasValidDateRange =
    values[FieldNames.StartDate] &&
    values[FieldNames.EndDate] &&
    new Date(values[FieldNames.StartDate]) <= new Date(values[FieldNames.EndDate])

  return loading || invalid || !hasValidDateRange || pristine
}
